import { render, staticRenderFns } from "./YoutubeComponent.vue?vue&type=template&id=a90ac1c4&scoped=true"
import script from "./YoutubeComponent.vue?vue&type=script&lang=js"
export * from "./YoutubeComponent.vue?vue&type=script&lang=js"
import style0 from "./YoutubeComponent.vue?vue&type=style&index=0&id=a90ac1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90ac1c4",
  null
  
)

export default component.exports